module.exports = __webpack_public_path__ + "static/media/54.80aa02c6.jpg";